import axios from "axios";
import { getToken } from "../../../auth/authService";

const api = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL + "/admin/official-sentences",
  headers: { "Content-Type": "application/json" },
});

api.interceptors.request.use((config) => {
  const token = getToken();
  console.log("[AdminOfficialSentence] Bearer token present:", !!token);
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  } else {
    console.warn("[AdminOfficialSentence] No token found, request may fail with 401");
  }
  return config;
});

// ===== CATEGORIES =====
export const fetchCategories = async (params = {}) => {
  try {
    const cleaned = Object.fromEntries(Object.entries(params).filter(([, v]) => v !== "" && v != null));
    console.log("[AdminOfficialSentence] Fetching categories, params:", cleaned);
    const res = await api.get("/categories", { params: cleaned });
    console.log("[AdminOfficialSentence] Categories response:", res.status, res.data);
    return { status: res.status, data: res.data };
  } catch (err) {
    console.error("[AdminOfficialSentence] Categories failed:", err.response?.status, err.response?.data);
    return { status: err.response?.status || 500, message: err.response?.data?.message || "Failed to fetch categories" };
  }
};

export const fetchCategoryById = async (id) => {
  try {
    console.log("[AdminOfficialSentence] Fetching category by id:", id);
    const res = await api.get(`/categories/${id}`);
    console.log("[AdminOfficialSentence] Fetch category by id response:", res.status, res.data);
    return { status: res.status, data: res.data };
  } catch (err) {
    console.error("[AdminOfficialSentence] Fetch category by id failed:", id, err.response?.status, err.response?.data);
    return { status: err.response?.status || 500, message: err.response?.data?.message || "Failed to fetch" };
  }
};

export const createCategory = async (data) => {
  try {
    console.log("[AdminOfficialSentence] Creating category:", data);
    const res = await api.post("/categories", data);
    console.log("[AdminOfficialSentence] Create category response:", res.status, res.data);
    return { status: res.status, data: res.data };
  } catch (err) {
    console.error("[AdminOfficialSentence] Create category failed:", err.response?.status, err.response?.data);
    return { status: err.response?.status || 500, message: err.response?.data?.message || "Create failed" };
  }
};

export const updateCategory = async (id, data) => {
  try {
    console.log("[AdminOfficialSentence] Updating category id:", id, "data:", data);
    const res = await api.put(`/categories/${id}`, data);
    console.log("[AdminOfficialSentence] Update category response:", res.status, res.data);
    return { status: res.status, data: res.data };
  } catch (err) {
    console.error("[AdminOfficialSentence] Update category failed:", id, err.response?.status, err.response?.data);
    return { status: err.response?.status || 500, message: err.response?.data?.message || "Update failed" };
  }
};

export const deleteCategory = async (id) => {
  try {
    console.log("[AdminOfficialSentence] Deleting category id:", id);
    const res = await api.delete(`/categories/${id}`);
    console.log("[AdminOfficialSentence] Delete category response:", res.status);
    return { status: res.status };
  } catch (err) {
    console.error("[AdminOfficialSentence] Delete category failed:", id, err.response?.status, err.response?.data);
    return { status: err.response?.status || 500, message: err.response?.data?.error || err.response?.data?.message || "Delete failed" };
  }
};

// ===== OPTIONS =====
export const fetchSentenceOptions = async () => {
  try {
    console.log("[AdminOfficialSentence] Fetching options");
    const res = await api.get("/options");
    console.log("[AdminOfficialSentence] Options response:", res.status, res.data);
    return { status: res.status, data: res.data };
  } catch (err) {
    console.error("[AdminOfficialSentence] Options failed:", err.response?.status, err.response?.data);
    return { status: err.response?.status || 500, message: err.response?.data?.message || "Failed to fetch options" };
  }
};

// ===== SENTENCES =====
export const fetchOfficialSentences = async (params) => {
  try {
    console.log("[AdminOfficialSentence] Fetching all sentences, params:", params);
    const res = await api.get("", { params });
    console.log("[AdminOfficialSentence] Fetch all response:", res.status, res.data);
    return { status: res.status, data: res.data };
  } catch (err) {
    console.error("[AdminOfficialSentence] Fetch all failed:", err.response?.status, err.response?.data);
    return { status: err.response?.status || 500, message: err.response?.data?.message || "Failed to fetch" };
  }
};

export const fetchOfficialSentenceById = async (id) => {
  try {
    console.log("[AdminOfficialSentence] Fetching sentence by id:", id);
    const res = await api.get(`/${id}`);
    console.log("[AdminOfficialSentence] Fetch by id response:", res.status, res.data);
    return { status: res.status, data: res.data };
  } catch (err) {
    console.error("[AdminOfficialSentence] Fetch by id failed:", id, err.response?.status, err.response?.data);
    return { status: err.response?.status || 500, message: err.response?.data?.message || "Failed to fetch" };
  }
};

export const createOfficialSentence = async (data) => {
  try {
    console.log("[AdminOfficialSentence] Creating sentence:", data);
    const res = await api.post("", data);
    console.log("[AdminOfficialSentence] Create response:", res.status, res.data);
    return { status: res.status, data: res.data };
  } catch (err) {
    console.error("[AdminOfficialSentence] Create failed:", err.response?.status, err.response?.data);
    return { status: err.response?.status || 500, message: err.response?.data?.message || "Create failed" };
  }
};

export const updateOfficialSentence = async (id, data) => {
  try {
    console.log("[AdminOfficialSentence] Updating sentence id:", id, "data:", data);
    const res = await api.put(`/${id}`, data);
    console.log("[AdminOfficialSentence] Update response:", res.status, res.data);
    return { status: res.status, data: res.data };
  } catch (err) {
    console.error("[AdminOfficialSentence] Update failed:", id, err.response?.status, err.response?.data);
    return { status: err.response?.status || 500, message: err.response?.data?.message || "Update failed" };
  }
};

export const deleteOfficialSentence = async (id) => {
  try {
    console.log("[AdminOfficialSentence] Deleting sentence id:", id);
    const res = await api.delete(`/${id}`);
    console.log("[AdminOfficialSentence] Delete response:", res.status);
    return { status: res.status };
  } catch (err) {
    console.error("[AdminOfficialSentence] Delete failed:", id, err.response?.status, err.response?.data);
    return { status: err.response?.status || 500, message: err.response?.data?.message || "Delete failed" };
  }
};
